import { useOrganizationUpdaterProvider } from '@/context_providers/organization_context/OrganizationProvider';
import { StringKeys } from '@/resources/strings/StringKeys';
import { formatTimeAgo, formatTimeHour } from '@/utils/time/formatTime';
import { Close } from '@mui/icons-material';
import {
  Card,
  CardContent,
  CardHeader,
  Container,
  IconButton,
  Link,
  Popover,
  Stack,
  Typography,
} from '@mui/material';
import { t } from 'i18next';

const LostConnectionInfoWindow = ({
  userAuthId,
  lastUpdated,
  updateLostConnectionInfo,
  isOpen,
}) => {
  const { groups } = useOrganizationUpdaterProvider();

  if (!userAuthId) return null;

  const getUserInfo = () => {
    if (!groups || !Array.isArray(groups)) return <></>;

    for (const group of groups) {
      if (!group) continue;
      const userDetails = group.group_value?.find(
        (user) => user.auth_id === userAuthId,
      );
      if (userDetails) {
        const info = {
          groupName: group.group_name,
          firstName: userDetails.first_name,
          lastName: userDetails.last_name,
          phoneNumber: userDetails.phone_number,
          role: userDetails.role,
          userAuthId: userAuthId,
        };
        return info;
      }
    }
    return null;
  };

  const userInfo = getUserInfo();

  return (
    <Popover
      sx={{
        width: '100%',
        position: 'fixed',
        top: '25%',
        left: '40%',
        borderRadius: '15px',
      }}
      open={isOpen}
    >
      <Card>
        <CardHeader
          action={
            <IconButton
              onClick={() =>
                updateLostConnectionInfo({
                  userAuthId: undefined,
                  isVisible: false,
                })
              }
            >
              <Close />
            </IconButton>
          }
        />
        <CardContent>
          <Stack sx={{ textAlign: 'center' }} spacing={1}>
            <Typography style={{ fontWeight: 'bold' }}>
              {t(StringKeys.NAME_LOST_CONNECTION, {
                name: `${userInfo?.firstName} ${userInfo?.lastName}`,
              })}
            </Typography>
            <Stack spacing={1}>
              <Container>
                <Typography>
                  <Link href={`tel:${userInfo?.phoneNumber}`}>
                    {userInfo?.phoneNumber}{' '}
                  </Link>
                </Typography>
                <Typography>
                  {t(StringKeys.GROUP)}: {userInfo?.groupName}
                </Typography>
              </Container>

              <Container>
                <Typography>
                  {t(StringKeys.NAME_NOT_SHARING_LOCATION, {
                    name: `${userInfo?.firstName}`,
                  })}
                </Typography>
                <Typography>
                  {t(StringKeys.LAST_SEEN_AT)} {formatTimeHour(lastUpdated)},
                  {<br />}
                  {formatTimeAgo(lastUpdated)}
                </Typography>
              </Container>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Popover>
  );
};

export default LostConnectionInfoWindow;
